import * as React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { History, Location } from 'history'
import CopySearchListPage from 'copyEditor/searchList'
import CopyEditPage from 'copyEditor/editForm'
import SearchBar from 'uiComponents/search/searchBar'
import { BaseRouteParams, withNavigation } from 'hocs'
import { Navigation } from 'navigation'
import { match as RouteMatch } from 'react-router-dom'
import './copyEditor.scss'
import { NavigationBack } from 'uiComponents/navigation/navigationBack'
import InSectionTabsSlot from 'uiComponents/navigation/sectionTabsSlot'
import EngageSectionTabs from 'engage/sectionTabs'
import { useAppSelector } from 'store/hooks'
import { showErrorMessage } from 'uiComponents/message'
import { useTranslation } from 'translations'

interface CopyEditorPageProps {
    history: History
    location: Location
    navigation: Navigation
    match: RouteMatch<BaseRouteParams>
}

function CopyEditorPage(props: CopyEditorPageProps) {
    const { t } = useTranslation()
    const user = useAppSelector((state) => state.auth.user)

    const searchByOpts = [
        { value: 'text', name: t('copyEditor.page.searchByText') },
        { value: 'key', name: t('copyEditor.page.searchByKey') },
    ]

    const onSearch = () => {
        // navigate to list even if search params haven't changed
        if (location.pathname.indexOf('engage/copy_editor/edit/') > -1) {
            props.history.push(`/account/${props.match.params.accountSlug}/engage/copy_editor/home${location.search}`)
        }
    }

    const isEditPage = props.location.pathname.indexOf('/copy_editor/edit/') > -1

    return (
        <div style={{ position: 'relative', marginBottom: '7em' }} id="copy-editor-page">
            {isEditPage ? (
                <InSectionTabsSlot>
                    <div className="detail-page-back">
                        <NavigationBack
                            onClick={() =>
                                props.history.push(
                                    `/account/${props.match.params.accountSlug}/engage/copy_editor/home${props.location.search}`,
                                )
                            }
                            text="Back to search results"
                        />
                    </div>
                </InSectionTabsSlot>
            ) : (
                <EngageSectionTabs />
            )}
            <div>
                <SearchBar
                    searchByOptions={user?.isAdmin ? searchByOpts : searchByOpts.filter((o) => o.value !== 'slug')}
                    autoSearchByPatterns={[
                        [/ /, 'text'],
                        [/_/, 'key'],
                    ]}
                    defaultSearchBy="text"
                    minSearchLength={3}
                    maxSearchLength={130}
                    onSearch={onSearch}
                    showErrorMessage={showErrorMessage}
                />
                <Switch location={props.location}>
                    <Route
                        path="/account/:accountSlug/engage/copy_editor/home"
                        render={() => (
                            <CopySearchListPage history={props.history} accountSlug={props.match.params.accountSlug} />
                        )}
                    />
                    <Route
                        path="/account/:accountSlug/engage/copy_editor/edit/:copySlug"
                        render={() => (
                            <CopyEditPage history={props.history} accountSlug={props.match.params.accountSlug} />
                        )}
                    />
                    <Route
                        render={() => (
                            <Redirect to={`/account/${props.match.params.accountSlug}/engage/copy_editor/home`} />
                        )}
                    />
                </Switch>
            </div>
        </div>
    )
}

export default withNavigation(CopyEditorPage)
